import React from "react";
import DataTable, { IDataTableProps } from "react-data-table-component";

interface Props<T> extends IDataTableProps<T> {}
const Table = (props: Props<{}>) => {
  return <DataTable {...props} />;
};

export default Table;
